import { cn } from '@/lib/utils';
import type {
  DimensionPreferenceMode,
  DimensionPreferences,
} from '@/hooks/useDimensionPreferences';

interface DimensionsSectionProps {
  dimensionPrefs: DimensionPreferences;
  setDimensionMode: (mode: DimensionPreferenceMode) => void;
}

export function DimensionsSection({
  dimensionPrefs,
  setDimensionMode,
}: DimensionsSectionProps) {
  return (
    <section className="rounded-xl border border-telekinesis-neutral-800 bg-telekinesis-background-2 p-6">
      <h2 className="mb-5 text-sm font-medium text-telekinesis-neutral-50">
        Dimensions
      </h2>

      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="text-sm text-telekinesis-neutral-50">
            Display mode
          </div>
          <div className="mt-0.5 text-xs leading-relaxed text-telekinesis-neutral-200">
            {dimensionPrefs.mode === 'default'
              ? 'Units and decimal places are picked automatically using vehicle-engineering norms.'
              : 'Tweaks you make to individual values are remembered for the session.'}
          </div>
        </div>
        <div className="flex flex-shrink-0 items-center gap-1 rounded-full border border-telekinesis-neutral-700 p-0.5">
          {(['default', 'custom'] as const).map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => setDimensionMode(m)}
              className={cn(
                'rounded-full px-3 py-1 text-xs font-medium capitalize transition-colors',
                dimensionPrefs.mode === m
                  ? 'bg-telekinesis-gold/15 text-[#107d40]'
                  : 'text-telekinesis-neutral-200 hover:text-telekinesis-neutral-50',
              )}
            >
              {m}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
